import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useData } from '../contexts/DataContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiWifiOff } = FiIcons;

const OfflineNotice = () => {
  const { offlineMode } = useData();

  return (
    <AnimatePresence>
      {offlineMode && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          className="bg-red-600 text-white overflow-hidden"
        >
          <div className="px-4 py-2 text-sm font-medium text-center flex items-center justify-center space-x-2">
            <SafeIcon icon={FiWifiOff} className="w-4 h-4" />
            <span>You are currently offline. Changes will be saved locally and synced when you reconnect.</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default OfflineNotice;